import { useMemo } from "react";
import Chart from "../../../components/Charts/Chart";
import EmptyState from "../../../components/EmptyState/EmptyState";
import { barChartDataZoom } from "../../../lib/constants";
import { resizeObserver } from "../../../lib/utils";
import { IUserDistributions } from "../analyticsReportTypes";

interface IProps {
  userDistributions: IUserDistributions | undefined;
  type: keyof IUserDistributions;
}

export const Distribution = ({ userDistributions, type }: IProps) => {
  const options = useMemo(() => {
    if (!userDistributions) return null;
    if (userDistributions[type].length === 0) return null;

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}"
        }
      },
      dataZoom: barChartDataZoom(userDistributions[type].length),
      yAxis: {
        type: "category",
        inverse: true,
        // data: sessionProgress[type].map((s) => s._id),
        data: userDistributions[type]
          .filter((e) => e._id !== null)
          .map((e) => e.user_entity || e.user_department || e.user_management_level),
        axisLabel: {
          margin: 20
        }
      },
      series: [
        {
          type: "bar",
          data: userDistributions[type].filter((e) => e._id !== null).map((s) => s.count),
          barWidth: "10px"
        }
      ]
    };
  }, [userDistributions, type]);

  return (
    <>
      {!options && <EmptyState iconSize={70} title="No data found" icon="Smile" />}
      {options && <Chart options={options as any} resizeObserver={resizeObserver} />}
    </>
  );
};
